<ng-container *transloco="let t">
    <td-alert state="warning" class="mb-4 w-100" *ngIf="show">
        <div class="my-3">{{ t('app.outdated-data') }}</div>
    </td-alert>
</ng-container>
